export class ForecastTemplateConstantsV1 {
}
ForecastTemplateConstantsV1.HistoricalDataOutput = 'HistoricalData';
ForecastTemplateConstantsV1.ForecastDataOutput = 'ForecastData';
ForecastTemplateConstantsV1.JoinedDataOutput = 'JoinedData';
ForecastTemplateConstantsV1.ForecastDateColumn = 'ForecastDate';
ForecastTemplateConstantsV1.HistoricalValueColumn = 'HistoricalValue';
ForecastTemplateConstantsV1.ForecastValueColumn = 'ForecastValue';
//# sourceMappingURL=forecastTemplateConstantsV1.js.map